// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3zmPs","error":"Textarea_error__3yloy","readonly":"Textarea_readonly__2gkLR","disabled":"Textarea_disabled__1Lxzr"};